import {Col, Row} from "../_snowpack/pkg/antd.js";
import React from "../_snowpack/pkg/react.js";
import {useTranslation} from "../_snowpack/pkg/react-i18next.js";
import {formatDigits, formatNumber} from "../services/Formatters.js";
import {OptimizationTarget} from "../constants.js";
import {SolarPanelPane} from "./SolarPanel.js";
import {InfoCircleOutlined} from "../_snowpack/pkg/@ant-design/icons.js";
import {Documentation, toExplanation} from "../services/DocumentationService.js";
export const ResultTable = (props) => {
  const {t, i18n} = useTranslation();
  const {results, calculatorSettings, onOpenDocumentation} = props;
  if (!results) {
    return /* @__PURE__ */ React.createElement("div", null, "Invalid Data");
  }
  const panels = Array.from(Array(results?.numberOfPanels).keys()).map((x) => {
    return {index: x + 1, panelType: x >= results.numberOfPanelsFinancial ? OptimizationTarget.Green : OptimizationTarget.Money};
  });
  return /* @__PURE__ */ React.createElement("div", {
    className: "ant-table"
  }, /* @__PURE__ */ React.createElement(Row, {
    gutter: 12,
    className: "panelPane"
  }, /* @__PURE__ */ React.createElement(Col, {
    xs: 10,
    sm: 8,
    className: "emphasis"
  }, t("resultTable.numberOfPanels"), " ", panels.length, " ", /* @__PURE__ */ React.createElement(InfoCircleOutlined, {
    onClick: () => onOpenDocumentation(Documentation.NumberOfPanels, t("resultTable.recommendedPanels"))
  })), /* @__PURE__ */ React.createElement(Col, {
    xs: 14,
    sm: 16,
    className: "panelContainer"
  }, /* @__PURE__ */ React.createElement(SolarPanelPane, {
    panels
  }))), /* @__PURE__ */ React.createElement(Row, {
    gutter: 12,
    justify: "end"
  }, /* @__PURE__ */ React.createElement(Col, {
    span: 15
  }, t("resultTable.installedCapacity")), /* @__PURE__ */ React.createElement(Col, {
    span: 9
  }, formatDigits(results.numberOfPanels * calculatorSettings.kiloWattPeakPerPanel, 2, i18n.language), " kWp")), /* @__PURE__ */ React.createElement(Row, {
    gutter: 12,
    justify: "end"
  }, /* @__PURE__ */ React.createElement(Col, {
    span: 10
  }, t("resultTable.limitingFactor"), " ", /* @__PURE__ */ React.createElement(InfoCircleOutlined, {
    onClick: () => onOpenDocumentation(toExplanation(results.limitingFactor), t("resultTable.limitingFactor"))
  })), /* @__PURE__ */ React.createElement(Col, {
    span: 14
  }, t("resultTable.limitingFactorEnum." + results.limitingFactor), " ")), /* @__PURE__ */ React.createElement(Row, {
    gutter: 12,
    justify: "center"
  }, /* @__PURE__ */ React.createElement(Col, {
    span: 20
  }, t("resultTable.areaRequired"), " ", /* @__PURE__ */ React.createElement(InfoCircleOutlined, {
    onClick: () => onOpenDocumentation(Documentation.AreaRequired, t("resultTable.areaRequired"))
  })), /* @__PURE__ */ React.createElement(Col, {
    span: 4
  }, formatDigits(results.numberOfPanels * calculatorSettings.areaPerPanel, 0, i18n.language), " ㎡")), /* @__PURE__ */ React.createElement(Row, {
    gutter: 12,
    justify: "center"
  }, /* @__PURE__ */ React.createElement(Col, {
    span: 15
  }, t("resultTable.monthlyConsumption")), /* @__PURE__ */ React.createElement(Col, {
    span: 9
  }, /* @__PURE__ */ React.createElement("span", null, `${formatNumber(results.consumptionPerMonthInKwh, i18n.language)} kWh`))), /* @__PURE__ */ React.createElement(Row, {
    gutter: 12
  }, /* @__PURE__ */ React.createElement(Col, {
    span: 15
  }, t("resultTable.monthlyProduction")), /* @__PURE__ */ React.createElement(Col, {
    span: 9
  }, `${formatNumber(results.productionPerMonthInKwh, i18n.language)} kWh`)));
};
